module.exports = __webpack_public_path__ + "img/cf.cc5685df.svg";